/**
 * Section : Impact KPI — FOG Theme
 * 3D tilt + cursor glow + border shine on hover
 * Vanilla JS, no dependencies
 */
(function () {
  'use strict';

  /* ---- Guards ---- */
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(hover: hover)').matches) return;

  /* ---- Config ---- */
  var MAX_TILT = 8;
  var PERSPECTIVE = 1000;
  var LERP_HOVER = 0.15;
  var LERP_LEAVE = 0.08;
  var SNAP_THRESHOLD = 0.01;
  var SELECTOR = '.impact-kpis__card';

  /* ---- State ---- */
  var rafId = null;
  var cards = [];

  /* ---- Init ---- */
  function init() {
    var nodeList = document.querySelectorAll(SELECTOR);
    if (!nodeList.length) return;

    nodeList.forEach(function (card) {
      /* Inject glow layer */
      var glow = document.createElement('div');
      glow.className = 'impact-kpis__glow';
      card.appendChild(glow);

      /* Inject border-shine layer */
      var shine = document.createElement('div');
      shine.className = 'impact-kpis__border-shine';
      card.appendChild(shine);

      /* Mark card as JS-enhanced */
      card.classList.add('tilt-ready');

      cards.push({
        el: card,
        rect: null,
        targetRX: 0,
        targetRY: 0,
        currentRX: 0,
        currentRY: 0,
        isHovered: false
      });

      card.addEventListener('mouseenter', onEnter, { passive: true });
      card.addEventListener('mousemove', onMove, { passive: true });
      card.addEventListener('mouseleave', onLeave, { passive: true });
    });
  }

  /* ---- Helpers ---- */
  function getData(el) {
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].el === el) return cards[i];
    }
    return null;
  }

  function clamp(v, min, max) {
    return Math.max(min, Math.min(max, v));
  }

  /* ---- Events ---- */
  function onEnter() {
    var d = getData(this);
    if (!d) return;
    d.rect = this.getBoundingClientRect();
    d.isHovered = true;
    d.el.classList.add('tilt-active');
    if (!rafId) rafId = requestAnimationFrame(loop);
  }

  function onMove(e) {
    var d = getData(this);
    if (!d || !d.rect) return;

    var r = d.rect;
    var x = clamp((e.clientX - r.left) / r.width, 0, 1);
    var y = clamp((e.clientY - r.top) / r.height, 0, 1);

    d.targetRY = (x - 0.5) * 2 * MAX_TILT;
    d.targetRX = (0.5 - y) * 2 * MAX_TILT;

    /* Glow / border-shine position (pixels) */
    var px = e.clientX - r.left;
    var py = e.clientY - r.top;
    d.el.style.setProperty('--glow-x', px + 'px');
    d.el.style.setProperty('--glow-y', py + 'px');
  }

  function onLeave() {
    var d = getData(this);
    if (!d) return;
    d.isHovered = false;
    d.targetRX = 0;
    d.targetRY = 0;
    d.el.classList.remove('tilt-active');
  }

  /* ---- Animation loop ---- */
  function loop() {
    var anyActive = false;

    for (var i = 0; i < cards.length; i++) {
      var d = cards[i];
      var dx = d.targetRX - d.currentRX;
      var dy = d.targetRY - d.currentRY;
      var factor = d.isHovered ? LERP_HOVER : LERP_LEAVE;

      d.currentRX += dx * factor;
      d.currentRY += dy * factor;

      /* Snap to zero when close enough */
      if (Math.abs(dx) < SNAP_THRESHOLD && Math.abs(dy) < SNAP_THRESHOLD && !d.isHovered) {
        d.currentRX = 0;
        d.currentRY = 0;
      }

      if (Math.abs(d.currentRX) > 0.001 || Math.abs(d.currentRY) > 0.001) {
        anyActive = true;
        d.el.style.transform =
          'perspective(' + PERSPECTIVE + 'px)' +
          ' rotateX(' + d.currentRX.toFixed(2) + 'deg)' +
          ' rotateY(' + d.currentRY.toFixed(2) + 'deg)' +
          ' translateZ(0)';
      } else if (!d.isHovered) {
        d.el.style.transform = '';
      }
    }

    if (anyActive) {
      rafId = requestAnimationFrame(loop);
    } else {
      rafId = null;
    }
  }

  /* ---- Bootstrap ---- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
